if (!customElements.get('simpson-hub-drawer')) {
  customElements.define('simpson-hub-drawer', class extends DrawerComponent {
    get requiresBodyAppended() { return false; }
  });
}

if (!customElements.get('simpson-customer-hub')) {
  customElements.define('simpson-customer-hub', class extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('simpson-hub-drawer');
      if (!this.drawer) return;
      this.listeners = new AbortController();
      this.cartRevision = 0;
      this.offers = window.SimpsonHubOffers ? new window.SimpsonHubOffers(this) : null;
      this.schedule = window.SimpsonHubSchedule ? new window.SimpsonHubSchedule(this) : null;
      this.products = window.SimpsonHubProducts ? new window.SimpsonHubProducts(this) : null;
      this.currentView = 'home';
      this.loyaltyCatalog = window.SimpsonHubLoyaltyCatalog ? new window.SimpsonHubLoyaltyCatalog(this) : null;
      const options = { signal: this.listeners.signal };
      this.querySelector('[data-hub-close]').addEventListener('click', () => this.drawer.hide(), options);
      this.drawer.addEventListener('toggle', () => {
        if (this.drawer.open) this.prepareHub();
      }, options);
      this.addEventListener('click', (event) => {
        const destination = event.target.closest('[data-hub-go]');
        if (destination) {
          if (destination.dataset.hubGo === 'support') this.setSupportContext(destination);
          this.navigate(destination.dataset.hubGo);
        }
        const filter = event.target.closest('[data-hub-filter]');
        if (filter) this.filterOrders(filter);
        const chatButton = event.target.closest('[data-hub-chat]');
        if (chatButton) this.openChat(chatButton);
        if (event.target.closest('[data-hub-copy-order]')) this.copyOrder();
        if (event.target.closest('[data-hub-back]')) {
          const current = this.querySelector('[data-hub-view]:not([hidden])');
          this.navigate(current?.dataset.hubParent || 'home');
        }
        if (event.target.closest('[data-hub-cart]')) this.openPillarCart();
        const buyAgain = event.target.closest('[data-hub-buy-again]');
        if (buyAgain) this.buyAgain(buyAgain);
      }, options);
      document.addEventListener('click', async (event) => {
        if (!event.target.closest('[data-hub-cart-back]')) return;
        const drawer = document.getElementById('CartDrawer');
        if (!drawer?.hasAttribute('data-from-hub')) return;
        event.preventDefault();
        await drawer.hide();
        await new Promise((resolve) => setTimeout(resolve, 0));
        drawer.removeAttribute('data-from-hub');
        this.open(this.cartReturnFocus);
      }, options);
      document.addEventListener('drawer:handleAfterHide', (event) => {
        if (event.target.id === 'CartDrawer') event.target.removeAttribute('data-from-hub');
      }, options);
      this.drawer.addEventListener('drawer:handleAfterHide', (event) => {
        if (event.target === this.drawer) this.restorePage();
      }, options);
      document.addEventListener('cart:updated', (event) => {
        this.cartRevision += 1;
        this.cartRequest?.abort();
        if (event.detail?.cart) this.renderCart(event.detail.cart);
        else if (this.drawer.open) this.refreshCart();
      }, options);
      document.addEventListener('cart:refresh', () => {
        if (this.drawer.open) this.refreshCart();
      }, options);
      window.addEventListener('hashchange', () => {
        if (location.hash === '#simpson-hub') this.open();
      }, options);
      if (location.hash === '#simpson-hub') this.open();
      if (window.SimpsonHubAccount) this.account = new window.SimpsonHubAccount(this);
      this.account?.ready.then(() => {
        this.offers?.activate('home');
      }).catch(() => {});
      this.favorites = window.SimpsonHubFavorites ? new window.SimpsonHubFavorites(this) : null;
      if (this.drawer.open) this.favorites?.activate();
      if (window.SimpsonHubOrders) this.orders = new window.SimpsonHubOrders(this);
      const returnToRewards = () => {
        if (location.hash !== '#simpson-hub-rewards') return;
        const view = this.querySelector('[data-hub-view="loyalty"]');
        if (!view) return;
        this.navigate('loyalty');
        this.open();
      };
      window.addEventListener('hashchange', returnToRewards, options);
      window.addEventListener('pageshow', returnToRewards, options);
      returnToRewards();
      this.addEventListener('click', event => {
        if (event.target.closest('[data-hub-loyalty-enroll-link]')) {
          history.replaceState(history.state, '', location.pathname + location.search + '#simpson-hub-rewards');
        }
      }, options);
      const contactResult = this.querySelector('[data-hub-contact-result]');
      if (contactResult && location.hash === `#${contactResult.closest('form').id}`) {
        this.navigate('support');
        Promise.resolve(this.open()).then(() => contactResult.focus());
      }
    }

    disconnectedCallback() {
      this.shopButtonStyleObserver?.disconnect();
      this.loyaltyCatalog?.destroy();
      this.favorites?.destroy();
      this.products?.destroy();
      this.chatRequest?.abort();
      this.clearChatReturn();
      this.orders?.destroy();
      this.offers?.destroy();
      this.schedule?.destroy();
      this.account?.destroy();
      this.listeners?.abort();
      this.cartRequest?.abort();
      if (this.drawer?.open) {
        this.drawer.hide();
        this.restorePage();
      }
    }

    open(trigger) {
      if (this.drawer.open) return;
      const closeChat = this.chatIsOpen();
      this.clearChatReturn();
      if (closeChat) this.findChatControl('button[aria-label="Close chat"]')?.click();
      return this.drawer.show(trigger || document.activeElement);
    }

    prepareHub() {
      this.account?.ready.then(() => {
        if (this.drawer.open) this.offers?.activate(this.currentView);
      }).catch(() => {});
      this.loyaltyCatalog?.activate(this.currentView);
      this.favorites?.activate();
      this.products?.activate();
      this.setupSocialSignIn();
      this.querySelectorAll('[data-hub-sign-in]').forEach(login => {
        const url = new URL(login.href, location.origin);
        url.searchParams.set('return_to', `${location.pathname}${location.search}#simpson-hub`);
        login.href = url.href;
      });
      this.refreshCart();
    }

    setupSocialSignIn() {
      if (this.dataset.customerId || this.socialSignInStarted) return;
      const welcome = this.querySelector('.customer-hub__welcome');
      const email = welcome?.querySelector('[data-hub-sign-in]');
      if (!email) return;
      this.socialSignInStarted = true;
      welcome.style.gap = '12px';
      const shopSignIn = welcome.querySelector('[data-hub-shop-sign-in]');
      if (shopSignIn) shopSignIn.style.marginTop = '0';
      this.styleShopSignIn();
      const options = document.createElement('div');
      options.className = 'customer-hub__social-sign-in';
      options.style.cssText = 'display:grid;gap:12px;margin:0;';
      const google = document.createElement('a');
      google.className = 'customer-hub__button customer-hub__button--secondary';
      google.style.cssText = 'width:100%;background:#fff;color:#202124;border:1px solid #dadce0;min-height:48px;justify-content:center;gap:10px;';
      const googleLogo = document.createElement('img');
      googleLogo.src = 'https://developers.google.com/static/identity/images/g-logo.png';
      googleLogo.alt = '';
      googleLogo.width = 20;
      googleLogo.height = 20;
      googleLogo.style.cssText = 'width:20px;height:20px;flex-shrink:0;object-fit:contain;';
      const googleLabel = document.createElement('span');
      googleLabel.textContent = 'Continue with Google';
      google.append(googleLogo, googleLabel);
      google.dataset.hubSignIn = '';
      const url = new URL(email.href, location.origin);
      url.searchParams.set('acr_values', 'provider:google');
      google.href = url.href;
      options.append(google);
      const facebook = google.cloneNode(true);
      const facebookLogo = facebook.querySelector('img');
      facebookLogo.src = 'https://www.facebook.com/images/fb_icon_325x325.png';
      facebook.querySelector('span').textContent = 'Continue with Facebook';
      const facebookUrl = new URL(email.href, location.origin);
      facebookUrl.searchParams.set('acr_values', 'provider:facebook');
      facebook.href = facebookUrl.href;
      options.append(facebook);
      welcome.append(options);

    }

    styleShopSignIn() {
      const button = this.querySelector('[data-hub-shop-sign-in] shop-login-button');
      if (!button) return;
      customElements.whenDefined('shop-login-button').then(() => {
        if (!this.isConnected) return;
        const root = button.shadowRoot;
        if (!root) return;
        const style = document.createElement('style');
        style.textContent = 'button{width:100%!important;min-height:48px;box-sizing:border-box;background:#fff!important;color:#202124!important;border:1px solid #dadce0!important;border-radius:7px!important;}button>span{color:inherit!important;font-size:13px!important;font-weight:600!important;letter-spacing:normal!important;}button:enabled:hover{background:#f8f9fa!important;}';
        const apply = () => { if (!root.contains(style)) root.append(style); };
        apply();
        // Preserve the cosmetic override when Shopify refreshes its button markup.
        this.shopButtonStyleObserver = new MutationObserver(apply);
        this.shopButtonStyleObserver.observe(root, { childList: true });
      });
    }

    navigate(destination) {
      const view = Array.from(this.querySelectorAll('[data-hub-view]')).find((item) => item.dataset.hubView === destination);
      if (!view) return;
      this.querySelectorAll('[data-hub-view]').forEach((item) => { item.hidden = item !== view; });
      this.currentView = destination;
      this.loyaltyCatalog?.activate(destination);
      this.favorites?.activate();
      this.querySelector('[data-hub-back]').hidden = destination === 'home';
      this.querySelectorAll('.customer-hub__bottom [data-hub-go]').forEach((button) => {
        if (button.dataset.hubGo === (view.dataset.hubNav || view.dataset.hubParent || destination)) button.setAttribute('aria-current', 'page');
        else button.removeAttribute('aria-current');
      });
      this.querySelector('.customer-hub__content').scrollTop = 0;
      view.querySelector('[tabindex="-1"]')?.focus();
      this.account?.activate(destination).then(() => {
        if (this.currentView === destination) this.offers?.activate(destination);
        if (this.currentView === destination) return this.orders?.activate(destination);
      }).catch(() => {
        if (this.currentView === destination) this.account.status('connection_failed', [], destination);
        this.account.controls();
      });
    }

    filterOrders(button) {
      if (this.orders?.filter(button)) return;
      const view = button.closest('[data-hub-view]');
      view.querySelectorAll('[data-hub-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const shipmentUnavailable = button.dataset.hubFilter === 'shipped' || button.dataset.hubFilter === 'delivered';
      view.querySelector('[data-hub-shipment-unavailable]').hidden = !shipmentUnavailable;
      let matches = 0;
      view.querySelectorAll('[data-hub-order-state]').forEach(card => {
        const filter = button.dataset.hubFilter;
        const matchesFilter = filter === 'all' || (filter === 'refunded' ? card.dataset.hubOrderRefunded === 'true' : card.dataset.hubOrderState === filter);
        card.hidden = !matchesFilter;
        if (!card.hidden) matches++;
      });
      view.querySelector('[data-hub-filter-empty]').hidden = shipmentUnavailable || matches > 0;
    }

    setSupportContext(button) {
      const view = this.querySelector('[data-hub-view="support"]');
      this.supportOrder = button.dataset.hubOrderName || '';
      view.querySelector('[data-hub-support-order]').textContent = this.supportOrder;
      view.querySelector('[data-hub-support-context]').hidden = !this.supportOrder;
      view.dataset.hubParent = button.dataset.hubOrderParent || 'home';
      view.dataset.hubNav = this.supportOrder ? 'orders' : 'support';
      view.querySelector('[data-hub-support-status]').textContent = '';
      const orderField = view.querySelector('[data-hub-contact-order]');
      if (orderField) orderField.value = this.supportOrder;
    }

    async copyOrder() {
      const status = this.querySelector('[data-hub-support-status]');
      try {
        await navigator.clipboard.writeText(this.supportOrder);
        status.textContent = this.dataset.copySuccess;
      } catch { status.textContent = this.dataset.copyError; }
    }

    findChatControl(selector) {
      const host = document.querySelector('shopify-chat');
      const search = root => {
        if (!root) return null;
        const launcher = root.querySelector(selector);
        if (launcher) return launcher;
        for (const element of root.querySelectorAll('*')) {
          const found = element.shadowRoot && search(element.shadowRoot);
          if (found) return found;
        }
        return null;
      };
      return search(host?.shadowRoot) || search(host);
    }

    findChatLauncher() {
      return this.findChatControl('button[part="activator"], button[aria-label="Chat"]');
    }

    chatIsOpen() {
      const host = document.querySelector('shopify-chat');
      if (host?.hasAttribute('open')) { this.chatUsesHostState = true; return true; }
      if (this.chatUsesHostState) return false;
      return this.findChatLauncher()?.getAttribute('aria-expanded') === 'true';
    }

    async waitForChat(check, signal, timeout = 6000) {
      const deadline = Date.now() + timeout;
      while (!signal.aborted && this.isConnected) {
        const result = check();
        if (result) return result;
        if (Date.now() >= deadline) break;
        await new Promise(resolve => {
          const finish = () => { clearTimeout(timer); signal.removeEventListener('abort', finish); resolve(); };
          const timer = setTimeout(finish, 150);
          signal.addEventListener('abort', finish, { once: true });
        });
      }
      return null;
    }

    clearChatReturn() {
      this.chatObserver?.disconnect();
      this.chatObserver = null;
      this.chatSession = false;
    }

    watchChatClose() {
      const host = document.querySelector('shopify-chat');
      const launcher = this.findChatLauncher();
      this.chatSession = true;
      this.chatObserver = new MutationObserver(() => {
        if (this.chatSession && !this.chatIsOpen()) this.returnFromChat();
      });
      if (host) this.chatObserver.observe(host, { attributes: true, attributeFilter: ['open'] });
      if (launcher) this.chatObserver.observe(launcher, { attributes: true, attributeFilter: ['aria-expanded'] });
      // The shell can replace its activator while opening; the host state remains authoritative.
      if (!this.chatIsOpen()) this.returnFromChat();
    }

    returnFromChat() {
      if (!this.chatSession) return;
      const trigger = this.chatReturnFocus;
      this.clearChatReturn();
      if (!this.isConnected) return;
      this.open(trigger);
      this.querySelector('[data-hub-support-status]').textContent = '';
    }

    async openChat(button) {
      if (this.chatOpening) return;
      const status = this.querySelector('[data-hub-support-status]');
      this.chatOpening = true;
      this.chatRequest = new AbortController();
      const { signal } = this.chatRequest;
      const trigger = button || this.querySelector('[data-hub-chat]');
      const initiallyDisabled = trigger.disabled;
      trigger.disabled = true;
      trigger.setAttribute('aria-busy', 'true');
      status.textContent = this.dataset.chatLoading;
      this.chatReturnFocus = trigger;
      try {
        const launcher = await this.waitForChat(() => this.findChatLauncher(), signal);
        if (signal.aborted || !this.isConnected) return;
        if (!launcher || !this.drawer.open || this.currentView !== 'support') {
          status.textContent = this.dataset.chatError;
          return;
        }
        status.textContent = '';
        await this.drawer.hide();
        await new Promise(resolve => setTimeout(resolve, 0));
        if (signal.aborted || !this.isConnected) return;
        if (!this.chatIsOpen()) this.findChatLauncher()?.click();
        const opened = await this.waitForChat(() => this.chatIsOpen(), signal, 4000);
        if (signal.aborted || !this.isConnected) return;
        if (!opened) { this.open(trigger); status.textContent = this.dataset.chatError; return; }
        this.watchChatClose();
      } catch {
        if (!signal.aborted && this.isConnected) {
          this.clearChatReturn();
          this.open(trigger);
          status.textContent = this.dataset.chatError;
        }
      } finally {
        this.chatOpening = false;
        trigger.disabled = initiallyDisabled;
        trigger.removeAttribute('aria-busy');
      }
    }

    async openPillarCart() {
      const drawer = document.getElementById('CartDrawer');
      const status = this.querySelector('[data-hub-navigation-status]');
      if (!drawer || typeof drawer.show !== 'function') {
        status.textContent = this.dataset.cartError;
        return;
      }
      status.textContent = '';
      this.cartReturnFocus = this.drawer.activeElement;
      if (this.drawer.open) await this.drawer.hide();
      await new Promise((resolve) => setTimeout(resolve, 0));
      drawer.setAttribute('data-from-hub', '');
      await drawer.show(this.cartReturnFocus);
    }

    async buyAgain(button) {
      if (this.adding) return;
      const id = Number(button.dataset.hubBuyAgain);
      if (!Number.isSafeInteger(id) || id <= 0) return;
      this.adding = true;
      const status = button.parentElement.querySelector('[data-hub-add-status]');
      const buttons = Array.from(this.querySelectorAll('[data-hub-buy-again], [data-favorites-cart]'));
      buttons.forEach((item) => { item.disabled = true; });
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      let added = false;
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
          signal: AbortSignal.timeout(20000)
        });
        if (!response.ok) {
          const error = await response.json().catch(() => null);
          status.textContent = response.status < 500 ? (typeof error?.description === 'string' ? error.description : this.dataset.addError) : this.dataset.addUncertain;
          await this.refreshCart();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        added = true;
        status.textContent = this.dataset.addSuccess;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        await this.refreshCart();
        if (this.drawer.open) await this.openPillarCart();
      } catch (error) {
        status.textContent = added ? this.dataset.addSuccess : this.dataset.addUncertain;
        if (!added) {
          await this.refreshCart();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } finally {
        this.adding = false;
        buttons.forEach((item) => { item.disabled = false; });
        button.removeAttribute('aria-busy');
        if (this.drawer.open && document.activeElement === document.body && !button.closest('[data-hub-view]').hidden) button.focus();
      }
    }

    restorePage() {
      if (['#simpson-hub', '#simpson-hub-rewards'].includes(location.hash)) history.replaceState(history.state, '', `${location.pathname}${location.search}`);
    }

    async refreshCart() {
      this.cartRequest?.abort();
      this.cartRequest = new AbortController();
      const revision = ++this.cartRevision;
      try {
        const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', signal: this.cartRequest.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (revision === this.cartRevision) this.renderCart(cart);
      } catch (error) {
        if (error.name !== 'AbortError' && revision === this.cartRevision) this.querySelector('[data-hub-cart-status]').textContent = this.dataset.cartError;
      }
    }

    renderCart(cart) {
      if (!Number.isFinite(cart.item_count) || !Number.isFinite(cart.items_subtotal_price) || !cart.currency) {
        this.querySelector('[data-hub-cart-status]').textContent = this.dataset.cartError;
        return;
      }
      this.offers?.syncCart(cart);
      this.querySelector('[data-hub-cart-count]').textContent = cart.item_count;
      this.querySelector('[data-hub-cart-total]').textContent = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: cart.currency }).format(cart.items_subtotal_price / 100);
      this.querySelector('[data-hub-cart-status]').textContent = '';
    }
  });
}
